module.exports = __webpack_public_path__ + "img/VIETBANK.a7a91bf3.svg";